
const headers = [
    {
      label: 'ชื่อกลุ่ม',
      field: 'name',
    },
    {
      label: 'สถานะการใช้งาน',
      field: 'isActive',      
    },
    // {
    //   label: 'แก้ไขข้อมูลล่าสุด',
    //   field: 'updateDate', 
    // },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers